import { AuthenticatedLayout, type AuthenticatedLayoutProps, useCanQueryTenantData } from "@sg-protect/shell";
import { Outlet } from "react-router";
import { InitialCrawlModalTrigger } from "../InitialCrawlModalTrigger.tsx";
import { FlaggedUserDetailsCardProvider } from "./FlaggedUserDetailsCardProvider.tsx";
import { ModuleDataProviders } from "./ModuleDataProviders.tsx";
import { ModuleGates } from "./ModuleGates.tsx";

export type TenantAssessmentAuthenticatedLayoutProps = AuthenticatedLayoutProps;

function ConsentedInitialCrawlModalTrigger() {
    const canQueryTenantData = useCanQueryTenantData();

    return canQueryTenantData && <InitialCrawlModalTrigger />;
}

export const TenantAssessmentAuthenticatedLayout = ({
    mainContent = <Outlet />,
    isFullScreen,
    ...props
}: TenantAssessmentAuthenticatedLayoutProps) => {
    return (
        <AuthenticatedLayout
            {...props}
            isFullScreen={isFullScreen}
            mainContent={
                <ModuleDataProviders>
                    <FlaggedUserDetailsCardProvider>
                        <ModuleGates>{mainContent}</ModuleGates>
                    </FlaggedUserDetailsCardProvider>
                    {!isFullScreen && <ConsentedInitialCrawlModalTrigger />}
                </ModuleDataProviders>
            }
        />
    );
};
